import React, {useMemo} from "react";
import {Typography} from "antd";
import RedFlagInfo from "./info_components/RedFlagInfo";
import RedFlagContainer from "../red_flag/report_components/RedFlagContainer";
import ExpandableContainer from "./ExpandableContainer";
import "../Supervision.less";


const getGlobalRootData = (branch, args) => {
    switch (branch.level) {
        case "red_flag":
            return {
                text: branch.red_flag_name,
                infoComponent: <RedFlagInfo
                    clients_count={branch.problem_counters.clients}
                    representatives_count={branch.problem_counters.representatives}
                    all_clients={branch.problem_counters.clients}
                    all_representatives={branch.problem_counters.representatives}
                />,
                expandableComponent: <RedFlagContainer flag={branch}/>
            }
    }
}

const ReportConstructor = ({data, type = "flag", additionalClientInfo = null, description = ''}) => {
    const report = useMemo(() => {
        if (data) {
            return <div style={{marginTop: "15px", fontSize: "0.9em"}}>
                {data.map((branch, inx) => {
                    return <ExpandableContainer key={inx} {...getGlobalRootData(branch, additionalClientInfo)} />
                })}
            </div>
        }
        return null
    }, [data, type])

    return (
        <div className={'report-constructor'}>
            <Typography.Title level={4} className={'spas'}>
                Checks
            </Typography.Title>
            {description.split('\n').map((text, index) => {
                return <Typography.Paragraph key={index} className={'text'}>
                    {text}
                </Typography.Paragraph>
            })}
            {report}
        </div>
    )
}

export default ReportConstructor
